<template>
  <v-card flat>
    <FormField
      label="Nome da Forma de Entrega"
      v-model="form.nomeForma"
      :validation="$v.form.nomeForma"
    />
    <FormSelect
      label="Segmento do cliente"
      :options="segmentos"
      v-model="form.baseadaCliente.idSegmentoCliente"
      :validation="$v.form.baseadaCliente.idSegmentoCliente"
    />
    <h4 class="text-center">Detalhes de transporte</h4>
    <LineDivider></LineDivider>
    <FormField
      label="Descrição da forma de transporte"
      v-model="formaTransporte.descricaoFormaTransporte"
      :validation="$v.formaTransporte.descricaoFormaTransporte"
      personalizedMessage="Informe a descrição da forma de transporte"
    />
    <v-row>
      <v-col cols="12" md="6" class="py-0">
        <FormField
          label="CEP Inicial"
          v-model="formaTransporte.cepInicial"
          mask="#####-###"
          :validation="$v.formaTransporte.cepInicial"
          :personalizedMessage="mensagemErroCepInicial"
          @blur="validarCepInicial()"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <FormField
          label="CEP Final"
          v-model="formaTransporte.cepFinal"
          mask="#####-###"
          :validation="$v.formaTransporte.cepFinal"
          :personalizedMessage="mensagemErroCepFinal"
          @blur="validarCepFinal()"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <FormField
          label="Custo transporte"
          :money="formaTransporte.custoTransporte === null ? null : moneyMask"
          v-model="formaTransporte.custoTransporte"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <FormField
          label="Custo percentual do seguro"
          v-model="formaTransporte.custoPercentualSeguro"
          :money="
            formaTransporte.custoPercentualSeguro === null ? null : moneyMask
          "
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <FormField
          label="Peso Inicial"
          v-model="formaTransporte.pesoInicial"
          typeField="number"
          @blur="validarPesoInicial()"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <FormField
          label="Peso Final"
          v-model="formaTransporte.pesoFinal"
          typeField="number"
          @blur="validarPesoFinal()"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <FormField
          label="Quantidade de dias de preparo"
          v-model="formaTransporte.quantDiasPreparo"
          typeField="number"
          :validation="$v.formaTransporte.quantDiasPreparo"
          personalizedMessage="Informe a quantidade de dias de preparo"
          @blur="validarQuantDiasPreparo()"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <FormField
          label="Quantidade de dias de entrega"
          v-model="formaTransporte.quantDiasEntrega"
          typeField="number"
          :validation="$v.formaTransporte.quantDiasEntrega"
          personalizedMessage="Informe a quantidade de dias de entrega"
          @blur="validarQuantDiasEntrega()"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <FormField
          label="Total inicial do pedido"
          :money="
            formaTransporte.totalPedidoInicial === null ? null : moneyMask
          "
          v-model="formaTransporte.totalPedidoInicial"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <FormField
          label="Total final do pedido"
          :money="formaTransporte.totalPedidoFinal === null ? null : moneyMask"
          v-model="formaTransporte.totalPedidoFinal"
        />
      </v-col>
      <v-col cols="12" class="text-end">
        <span v-if="editingIndex !== null" class="d-inline-block mr-2">
          <FormButton text="Cancelar" outlined @click="cancelEdit" />
        </span>
        <FormButton
          :text="editingIndex !== null ? 'Atualizar' : 'Adicionar'"
          @click="addForma"
        />
      </v-col>
      <v-col cols="12" v-if="form.baseadaCliente.formas.length > 0">
        <v-simple-table responsive>
          <thead>
            <tr>
              <th class="text-center">Descrição</th>
              <th class="text-center">CEP Inicial</th>
              <th class="text-center">CEP Final</th>
              <th class="text-center">Custo Transporte</th>
              <th class="text-center">Custo % Seguro</th>
              <th class="text-center">Peso Inicial</th>
              <th class="text-center">Peso Final</th>
              <th class="text-center">Qtd dias Preparo</th>
              <th class="text-center">Qtd dias Entrega</th>
              <th class="text-center">Total Inicial</th>
              <th class="text-center">Total Final</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in form.baseadaCliente.formas" :key="i">
              <td class="text-center">{{ item.descricaoFormaTransporte }}</td>
              <td class="text-center">{{ item.cepInicial }}</td>
              <td class="text-center">{{ item.cepFinal }}</td>
              <td class="text-center">{{ item.custoTransporte }}</td>
              <td class="text-center">{{ item.custoPercentualSeguro }}</td>
              <td class="text-center">{{ item.pesoInicial }}</td>
              <td class="text-center">{{ item.pesoFinal }}</td>
              <td class="text-center">{{ item.quantDiasPreparo }}</td>
              <td class="text-center">{{ item.quantDiasEntrega }}</td>
              <td class="text-center">{{ item.totalPedidoInicial }}</td>
              <td class="text-center">{{ item.totalPedidoFinal }}</td>
              <td class="text-center">
                <div class="d-flex justify-center align-center">
                  <v-btn icon title="Editar" @click="editForma(i)">
                    <v-icon small color="primario">fas fa-pencil-alt</v-icon>
                  </v-btn>
                  <v-btn icon title="Excluir" @click="deleteForma(i)">
                    <v-icon small color="error">fas fa-trash-alt</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <FormSwitch
      v-model="form.permiteAgendamento"
      label="Permite agendamento"
      @click="form.idCalendarioEntrega = null"
    />
    <FormSelect
      v-if="form.permiteAgendamento"
      label="Calendário"
      :options="calendarios"
      v-model="form.idCalendarioEntrega"
    />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { SEGMENTO_CLIENTE_LIST } from "@/store/actions/segmento";
import {
  cepTransporteZerado,
  validacoesFormaTransporteCliente
} from "@/pages/cadastro/formasentrega/utils/validarFormaTransporteCliente";
import FormSelect from "@/components/form/FormSelect";
import FormField from "@/components/form/FormField";
import FormSwitch from "@/components/form/FormSwitch";
import FormButton from "@/components/form/FormButton";
import LineDivider from "@/components/LineDivider";

export default {
  name: "FormaEntregaFormCliente",
  components: {
    FormSelect,
    LineDivider,
    FormField,
    FormSwitch,
    FormButton
  },
  props: {
    calendarios: {
      type: [Array],
      default: () => ({}),
      required: true
    },
    data: {
      type: [Object],
      default: () => ({}),
      required: true
    }
  },
  validations: {
    form: {
      nomeForma: { required },
      baseadaCliente: {
        idSegmentoCliente: { required }
      }
    },
    formaTransporte: validacoesFormaTransporteCliente
  },
  data() {
    return {
      moneyMask: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        default: "",
        precision: 2,
        masked: false
      },
      isLoading: false,
      form: {},
      formaTransporte: {
        descricaoFormaTransporte: "",
        cepInicial: "",
        cepFinal: "",
        quantDiasPreparo: null,
        quantDiasEntrega: null
      },
      editingIndex: null,
      segmentos: []
    };
  },
  computed: {
    ...mapGetters(["getFornecedorId"]),
    mensagemErroCepInicial() {
      return cepTransporteZerado(this.formaTransporte.cepInicial)
        ? "CEP inicial não pode ser zerado"
        : "CEP inicial inválido";
    },
    mensagemErroCepFinal() {
      return cepTransporteZerado(this.formaTransporte.cepFinal)
        ? "CEP final não pode ser zerado"
        : "CEP final inválido";
    }
  },
  methods: {
    update() {
      this.$emit("update", this.form);
    },
    getSegmentos() {
      this.isLoading = true;
      this.$store
        .dispatch(SEGMENTO_CLIENTE_LIST, {
          idfornecedor: this.getFornecedorId
        })
        .then(data => {
          this.segmentos = (data || []).map(v => {
            return { value: v.idsegmentocliente, text: v.nome };
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    addForma() {
      this.$v.formaTransporte.$touch();
      if (this.$v.formaTransporte.$invalid) {
        return;
      }

      const forma = { ...this.formaTransporte };
      if (this.editingIndex !== null) {
        this.form.baseadaCliente.formas.splice(this.editingIndex, 1, forma);
        this.editingIndex = null;
      } else {
        this.form.baseadaCliente.formas.push(forma);
      }

      this.resetFormaTransporte();
      this.update();
    },
    editForma(i) {
      this.editingIndex = i;
      if (this.$v.formaTransporte) {
        this.$v.formaTransporte.$reset();
      }
      this.formaTransporte = { ...this.form.baseadaCliente.formas[i] };
    },
    cancelEdit() {
      this.editingIndex = null;
      this.resetFormaTransporte();
    },
    resetFormaTransporte() {
      this.formaTransporte = {
        descricaoFormaTransporte: "",
        cepInicial: "",
        cepFinal: "",
        quantDiasPreparo: null,
        quantDiasEntrega: null
      };
      if (this.$v.formaTransporte) {
        this.$v.formaTransporte.$reset();
      }
    },
    touchValidations() {
      this.$v.$touch();
    },
    getFormaTransportePendente() {
      return this.formaTransporte;
    },
    deleteForma(i) {
      if (this.editingIndex === i) {
        this.cancelEdit();
      } else if (this.editingIndex !== null && this.editingIndex > i) {
        this.editingIndex -= 1;
      }

      this.form.baseadaCliente.formas.splice(i, 1);
      this.update();
    },
    validarQuantDiasPreparo() {
      if (this.formaTransporte.quantDiasPreparo < 0) {
        this.formaTransporte.quantDiasPreparo = 0;
      }
    },
    validarQuantDiasEntrega() {
      if (this.formaTransporte.quantDiasEntrega < 0) {
        this.formaTransporte.quantDiasEntrega = 0;
      }
    },
    validarPesoInicial() {
      if (this.formaTransporte.pesoInicial < 0) {
        this.formaTransporte.pesoInicial = 0;
      }
    },
    validarPesoFinal() {
      if (this.formaTransporte.pesoFinal < 0) {
        this.formaTransporte.pesoFinal = 0;
      }
    },
    validarCepInicial() {
      if (this.$v.formaTransporte.cepInicial) {
        this.$v.formaTransporte.cepInicial.$touch();
      }
    },
    validarCepFinal() {
      if (this.$v.formaTransporte.cepFinal) {
        this.$v.formaTransporte.cepFinal.$touch();
      }
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit("update", this.form);
      }
    }
  },
  created() {
    this.getSegmentos();
    this.form = this.data;
  }
};
</script>
